var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFileManager = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.29 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Folder_3106664",
    "data-name": "noun Directory 3106664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46857",
    "data-name": "Path 46857",
    d: "M686.52,390.26H675.05a1.22,1.22,0,0,1-1.2-1.24V377.77a1.22,1.22,0,0,1,1.2-1.24h0s6.3-.1,6.77.1,1.07,2.4,1.07,2.4h7.23a1.22,1.22,0,0,1,1.2,1.24h0v4.06a3.66,3.66,0,0,0-1.5-.31,4,4,0,0,0-3.92,4.05,4.15,4.15,0,0,0,.62,2.19Zm-12.67-8.74v.62h17.47v-.62Zm16,10h0a3.44,3.44,0,1,1,3.31-3.55v.11A3.38,3.38,0,0,1,689.82,391.51Zm-.9-3.75v.63h.6V389h-.6v.62h1.81V389h-.6v-1.25Zm.6-1.25v.63h.6v-.62Z",
    transform: "translate(-673.85 -376.5)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFileManager);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_fileManager.3815ae0f9eabe38679593c8ee26bb055.svg";